import { trace } from 'owa-trace';
import {
    getSelectedTableView,
    MailRowDataPropertyGetter,
    type TableQueryType,
    type MailFolderTableQuery,
    isCatchUpFilter,
    isHeadlinesFilter,
} from 'owa-mail-list-store';

/**
 * This function determines if we should show any rollup at the top of the
 * mail list. This is shared logic between all of our rollup types.
 */
export default function shouldShowRollup(
    previousRowKey: string | null,
    currentRowKey: string
): boolean {
    if (!currentRowKey) {
        trace.warn('shouldShowRollup: currentRowId is not expected to be null');
        return false;
    }

    // Don't show rollups in non-folder tables
    const tableView = getSelectedTableView();
    const isFolderTable = tableView.tableQuery.type === 0;
    if (!isFolderTable) {
        return false;
    }

    // Don't show rollups in pinned items section
    if (MailRowDataPropertyGetter.getIsPinned(currentRowKey, tableView)) {
        return false;
    }

    // Don't show rollups in copilot catchup filters
    if (
        isCatchUpFilter(tableView.tableQuery as MailFolderTableQuery) ||
        isHeadlinesFilter(tableView.tableQuery as MailFolderTableQuery)
    ) {
        return false;
    }

    /**
     * Otherwise, when the current row is not pinned, show rollup on top of list
     * view if current row is the first row, or if the previous row is pinned.
     */
    return (
        previousRowKey === null || MailRowDataPropertyGetter.getIsPinned(previousRowKey, tableView)
    );
}
